module.exports = __webpack_public_path__ + "img/CattleyaoneHandedSword_07.fa210670.png";